<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">eSIM Batch Import</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>


      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
              >&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>

      <div v-else>

        <!-- Card stats -->
        <b-row>
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
							<span>
								This page will import (or trigger update) for an existing profile on the ESIM platform.
								Note all fields are required in the import file, see FILE FORMAT. If you need to only
								trigger the esim to update for changes to the carrier profile (profileType), you must
								send only the iccid to the profile.
							</span>

                <p>&nbsp;</p>

                <b-row>

                  <b-col lg="5">
                    <div class="input-group">
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text :style="ps">Profile Type</b-input-group-text>
                        </template>
                        <b-form-select
                            id="profileType"
                            size="md"
                            v-model="batchForm.profileType"
                            :options="profielTypeOptions"
                            :state="profileTypeValidation"
                        ></b-form-select>
                      </b-input-group>
                    </div>

                    <div class="input-group importFileGroup">
                      <b-input-group>
                        <template #prepend>
                          <b-input-group-text :style="ps">Import File</b-input-group-text>
                        </template>
                        <b-form-file
                            size="md"
                            v-model="batchForm.importFile"
                            accept=".csv,.xls,.xlsx"
                            @change="onLoadFileData($event)"
                            :state="importFileValidation"
                            class="browser-button mt-2 ml-2"
                            plain>
                        </b-form-file>
                      </b-input-group>
                    </div>

                    <div class="input-group">
                      <b-input-group>
                        <b-form-checkbox
                            id="triggerIccid"
                            size="md"
                            v-model="batchForm.triggerIccidStatus"
                            name="triggerIccidStatus"
                            value="1"
                            unchecked-value="0"
                            class="mt-2 trigger-iccid"
                        > *Trigger iccid update only
                        </b-form-checkbox>
                      </b-input-group>
                    </div>

                    <div class="text-sm text-info">
                      <br>
                      <em>*NOTE: The trigger iccid update only checkbox will only infrom the esim platform to update
                        the status and update if the carrier profile has changd.</em>
                    </div>

                  </b-col>

                  <b-col lg="7">
                    <div class="input-group">
                      <b-input-group>
                        <vue-json-to-csv
                            :json-data="template_data"
                            csv-title="esim_upload_template.csv">
                          <base-button type="info" title="Download a CSV template example" v-on:click="publicCode">
                            Download <i class="fa fa-download" aria-hidden="true"></i>
                          </base-button>
                        </vue-json-to-csv>
                        &nbsp;
                        <base-button
                            type="danger"
                            title="Upload your data to the server"
                            v-on:click="processBatchImport"
                            :disabled="!importFileValidation || !profileTypeValidation"
                        >
                          Upload <i class="fa fa-upload" aria-hidden="true"></i>
                        </base-button>
                      </b-input-group>
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="showPreviewData">
                  <b-col xl="12">
                    <p class="mt-2 font-weight-bold">Preview of import data:</p>
                    <div class="table-responsive">
                      <b-table
                          class="primary-table"
                          id="previewTable"
                          sticky-header="true"
                          :items="preview_items"
                          show-empty
                          striped
                          hover
                          :tbody-tr-class="rowClass"
                      >
                      </b-table>
                    </div>
                  </b-col>
                </b-row>

              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

      </div>

    </base-header>

    <!-- progress bar -->
    <b-modal
        centered
        size="sm"
        id="batch_progress_bar"
        title="Progress">
      <div class="text-center">
        <b-progress
            :max="totalCnt"
            show-progress
            height="2rem"
            class="w-100 mb-2">
          <b-progress-bar :value="currentCnt">
            <span><strong>{{ currentCnt }} of {{ totalCnt }}</strong></span>
          </b-progress-bar>
        </b-progress>
      </div>
      <div class="text-center">
        <small class="text-center">Processing ICCID: {{ iccid }}</small>
      </div>
      <template #modal-footer>
        <small class="text-center">{{ currentStatus }}</small>
      </template>
    </b-modal>

    <!-- report -->
    <b-modal
        centered
        size="sm"
        id="batch_progress_report"
        hide-footer
        header-bg-variant="info"
    >
      <template #modal-title>
        <span>Batch Import Results</span>
      </template>
      <div class="text-left mt-3">
        <p class="h4">Processed Total: {{ totalCnt }}</p>
      </div>
      <div class="text-left mt-3">
        <p class="h4">{{ success.length }} <span class="text-success">Successful</span></p>
      </div>
      <div class="text-left">
        <p class="h4">{{ errors.length }} <span class="text-danger">Failed</span></p>
      </div>
      <div class="text-left">
        <p class="h5">
          Please
          <vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
            <span class="text-primary cursor-pointer">click here</span>
          </vue-json-to-csv>
          to download a detailed list of processed SIMs.
        </p>
        <p class="h5">File Name :
          <vue-json-to-csv :json-data="reportData" :csv-title="processTitle">
            <span class="text-primary cursor-pointer">{{ processTitle + ".csv" }}</span>
          </vue-json-to-csv>
        </p>

      </div>
    </b-modal>

  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import * as XLSX from "xlsx";
import moment from "moment";
import VueJsonToCsv from "vue-json-to-csv";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";

export default {
  name: "BatchImportSims",
  components: {RouteBreadCrumb, VueJsonToCsv},
  data() {
    return {
      noAccess: true,
      ps: "background-color: rgba(94,114,228) !important;color: #FFFFFF !important;",
      currentCnt: 0,
      totalCnt: 0,
      currentStatus: '',

      showPreviewData: false,
      preview_items: [],

      file: File,
      arrayBuffer: null,
      filelist: null,
      template_data: [{
        "ICCID": "89999999999999999999",
        "PIN1": "9999",
        "PIN2": "9999",
        "PUK1": "99999999",
        "PUK2": "99999999",
        "IMSI": "999999999999999",
        "KI": "99999999999999999999999999999999",
        "OPC": "99999999999999999999999999999999",
        "PSK": "999999999999999999999999999999999999999999999999999999999999999",
        "ADM1": "OPTIONAL: 99999999",
        "KID": "OPTIONAL: 99999999999999999999999999999999",
        "KIC": "OPTIONAL: 99999999999999999999999999999999",
        "KIK": "OPTIONAL: 99999999999999999999999999999999",
        "DEK": "OPTIONAL: 99999999999999999999999999999999",
        "ACC": "OPTIONAL: 9999"
      }],
      batchForm: {
        profileType: "",
        importFile: null,
        triggerIccidStatus: "0",
      },
      profielTypeOptions: [],
      simImportRow: [],
      iccid: "",
      importData: [],
      importDataLength: 0,
      success: [],
      errors: [],
      progressStartValue: 5,
      onProgress: false,
      processTitle: "",
      reportData: [],
    };
  },

  computed: {

    profileTypeValidation() {
      return this.batchForm.profileType !== "";
    },

    importFileValidation() {
      return this.batchForm.importFile !== null;
    },

  },
  mounted() {
    document.title = "eSIM - Batch Import";

    if (!initService.getPortalAdminRole()) {
      this.$toast.error('NOTICE: This page is restricted to the DCC Portal Admin role.');
      return;
    } else {
      this.noAccess = false;
    }

    this.getProfileTypes();
    this.processTitle = moment(new Date()).format("YYYY-MM-DD") + "_processed";
  },

  methods: {

    rowClass(item, type) {
      if (!item) return;
      if (type !== 'row') return 'table-info';
      if (JSON.stringify(item).includes('INVALID')) return 'table-danger';
      return;
    },

    async loadPreviewData() {
      this.showPreviewData = true;
      this.preview_items = [];
      let data = this.importData;//.slice(0, 2);
      Object.keys(data).forEach(idx => {
        //console.log(idx,data[idx]);
        this.formatDataRow(data[idx]).then(row => {
          //console.log('row:',row[0]);
          this.preview_items.push(row[0]);
        });
      });


      //check invalid data
      if (JSON.stringify(this.preview_items).includes('INVALID')) {
        setTimeout(() => {
          this.$toast.error('NOTICE: The import identified ERRORS in the data.  Please review below.')
        }, 1500);
      }
    },

    //validate file format and headers
    //https://docs.sheetjs.com/docs/api/utilities
    onLoadFileData(event) {
      this.file = event.target.files[0];
      if (this.file) {
        new Promise((resolve, reject) => {
          let fileReader = new FileReader();
          fileReader.readAsArrayBuffer(this.file);
          fileReader.onload = e => {
            this.arrayBuffer = fileReader.result;
            let data = new Uint8Array(this.arrayBuffer);
            let arr = new Array();
            for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            let bstr = arr.join("");
            let wb = XLSX.read(bstr, {type: "binary"});
            let first_sheet_name = wb.SheetNames[0];
            let ws = wb.Sheets[first_sheet_name];
            let arraylist = XLSX.utils.sheet_to_json(ws, {raw: false});
            this.importData = arraylist;
            this.importDataLength = arraylist.length;
            this.loadPreviewData();
            fileReader.onerror = reject
          };
        })
      } else {
        this.showPreviewData = false;
      }
    },

    //format the data...
    async formatDataRow(data_in) {
      let data_out = [];
      //console.log('b4:data_in',data_in);
      data_in = commonService.EsimMapImportKeys(data_in);
      //console.log('af:data_in',data_in);
      Object.keys(data_in).forEach(field => {
        if (!commonService.validateData(field, data_in[field])) {
          data_in[field] = '!!INVALID!!' + data_in[field];
        }
      });
      data_out.push(data_in);
      return data_out;
    },

    // load the profile types drop down
    getProfileTypes() {
      eSimDashboardService.getProfileTypes().then(res => {
        this.profielTypeOptions.push({value: "", text: "Choose a profileType..."});
        res.data.profileTypes.map(item => {
          this.profielTypeOptions.push({value: item.profileTypeId, text: item.profileType});
        });
      });
    },

    // process all the sims loaded in batch.
    async processBatchImport() {

      if (!this.profileTypeValidation || !this.importFileValidation) {
        return false;
      }

      //clear last import
      this.success = [];
      this.errors = [];
      this.reportData = [];

      // Import ALL data in spreadsheet and show loading progress bar with updates for each item.
      this.$bvModal.show("batch_progress_bar");
      this.onProgress = true;
      this.progressStartValue = 5;
      this.setProgressTimer();
      this.currentStatus = '';

      for (let i = 0; i < this.importDataLength; i++) {

        this.currentCnt = (i + 1);
        this.totalCnt = this.importDataLength;

        //load the batch values not a single row and format
        let row = [];
        await this.formatDataRow(this.importData[i]).then(fmtData => {
          //console.log('fmtData:',fmtData[0]);
          row = fmtData[0];
        });
        this.iccid = row['ICCID'];
        //console.log('row:',row[0]);

        try {

          if (this.batchForm.triggerIccidStatus !== "0") {
            // Import but only do bump
            await new Promise((resolve, reject) => {
              // Process a bump only
              eSimDashboardService.bumpProfile(row['ICCID'], this.batchForm.profileType).then(res => {
                //console.log('bumpProfile:', row['ICCID'], ' response:', res);
                if (JSON.stringify(res).includes("Executed-Success")) {
                  //handle successs
                  this.success.push(row['ICCID']);
                  this.currentStatus = 'Import Successful';
                  this.reportData.push({ICCID: row['ICCID'], STATUS: "SUCCESS", DETAILS: 'Import Successful'});
                  resolve();
                } else {
                  let errMsg = '';
                  if (res.data.header.functionExecutionStatus.status === 'Failed') {
                    errMsg = String(res.data.header.functionExecutionStatus.statusCodeData.message);
                  } else {
                    errMsg = JSON.stringify(res.data);
                  }
                  this.currentStatus = errMsg;
                  this.errors.push(row['ICCID']);
                  this.reportData.push({
                    ICCID: row['ICCID'],
                    STATUS: "ERROR",
                    DETAILS: `${errMsg}`,
                  });
                  resolve();
                }
              }).catch(e => {
                this.errors.push(row['ICCID']);
                this.reportData.push({
                  ICCID: row['ICCID'],
                  STATUS: "ERROR",
                  DETAILS: JSON.stringify(e)
                });
                resolve();
              });
            });
          } else {
            // Import a New ESIM
            await new Promise((resolve, reject) => {
              eSimDashboardService
                  .addSimToProfile(encodeURIComponent(JSON.stringify(row)), this.batchForm.profileType)
                  .then(res => {
                    //console.log('SUCCESS:', row['ICCID'], ' response:', res);
                    if (JSON.stringify(res).includes("Executed-Success")) {
                      this.success.push(row['ICCID']);
                      this.currentStatus = 'Import Successful';
                      this.reportData.push({
                        ICCID: row['ICCID'],
                        STATUS: "SUCCESS",
                        DETAILS: 'Import Successful',
                      });
                      resolve();
                    } else {
                      let errMsg = '';
                      if (res.data.header.functionExecutionStatus.status === 'Failed') {
                        errMsg = String(res.data.header.functionExecutionStatus.statusCodeData.message);
                      } else {
                        errMsg = JSON.stringify(res.data);
                      }
                      this.currentStatus = errMsg;
                      this.errors.push(row['ICCID']);
                      this.reportData.push({
                        ICCID: row['ICCID'],
                        STATUS: "ERROR",
                        DETAILS: `${errMsg}`,
                      });
                      resolve();
                    }
                  }).catch(e => {
                //console.log('ERROR[2]:', row['ICCID'], ' response:', e);
                this.currentStatus = 'UNKNOWN';
                this.errors.push(row['ICCID']);
                this.reportData.push({
                  ICCID: row['ICCID'],
                  STATUS: "ERROR",
                  DETAILS: JSON.stringify(e)
                });
                resolve();
              });
            });
          }
        } catch (e) {
          if (this.errors[this.errors.length - 1] !== row['ICCID']) {
            //console.log('ERROR[3]:', row['ICCID'], ' response:', e);
            this.errors.push(row['ICCID']);
            this.reportData.push({
              ICCID: row['ICCID'],
              STATUS: "ERROR",
              DETAILS: JSON.stringify(e),
            });
          }
        }
      }
      this.processFinishFunc();
    },

    // use a timer for the progressbar
    setProgressTimer() {
      this.timer = setInterval(() => {
        this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
        if (this.progressStartValue > 100) {
          this.progressStartValue = 10;
        }
      }, 1000);
    },

    // create report of FAILED and SUCCESS list of processed iccid.
    processFinishFunc() {
      setTimeout(() => {
        this.$bvModal.hide("batch_progress_bar");
        this.onProgress = false;
      }, 1000);
      setTimeout(() => {
        this.$bvModal.show("batch_progress_report");
      }, 1500);
    },

    publicCode() {
      eSimDashboardService.pushESimTemplateVariable(this.profileType).then(res => {
        console.log(res)
      })
    },

  },
};
</script>